module.exports = __webpack_public_path__ + "a8d30fdde0c82eac847e770f2e48594e.MP3";